const SET_IS_LOCKED = 'SET_IS_LOCKED';

export default SET_IS_LOCKED;



// WEBPACK FOOTER //
// ./src/containers/IsLocked/constants.js